<template>
  <div class="holiday-admin">
    <!-- 年選択ヘッダー -->
    <div class="admin-header">
      <h2>📅 公式休日カレンダー（{{ selectedYear }}年）</h2>
      <div class="year-selector-container">
        <label for="year-select">年を選択:</label>
        <select 
          id="year-select"
          v-model="selectedYear" 
          class="year-selector"
        >
          <option v-for="year in availableYears" :key="year" :value="year">
            {{ year }}年
          </option>
        </select>
      </div>
    </div>

    <!-- カレンダーベースコンポーネントを管理モードで使用 -->
    <CalendarBase mode="admin" :year="selectedYear" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import CalendarBase from '../components/CalendarBase.vue'

const currentYear = new Date().getFullYear()
const selectedYear = ref(currentYear)

// 利用可能な年（現在年〜3年後）
const availableYears = computed(() => {
  const years = []
  for (let i = 0; i < 4; i++) {
    years.push(currentYear + i)
  }
  return years
})
</script>

<style scoped>
.holiday-admin {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem;
  background: #f8fafc;
  min-height: 100vh;
}

.admin-header {
  text-align: center;
  margin-bottom: 2rem;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.admin-header h2 {
  color: #1f2937;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.year-selector-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.year-selector-container label {
  font-weight: 600;
  color: #374151;
  font-size: 1rem;
}

.year-selector {
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.year-selector:hover {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.year-selector:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* モバイル対応 */
@media (max-width: 768px) {
  .holiday-admin {
    padding: 0.5rem;
  }
  
  .admin-header {
    padding: 1.5rem 1rem;
  }
  
  .admin-header h2 {
    font-size: 1.5rem;
  }
  
  .year-selector-container {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
